import { useMutation, useQueryClient } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

const ALLOWED_PAYMENT_METHODS_API_PATH =
  '/payment-processor/allowed-payment-methods';
const ALLOWED_PAYMENT_METHODS_MODE_API_PATH =
  '/payment-processor/allowed-payment-methods/mode';

export interface PaymentMethodsConfig {
  [key: string]: 'on' | 'off';
}

interface UpdateAllowedPaymentMethodsParams {
  locationId: string;
  paymentMethodConfigId?: string;
  paymentMethods: PaymentMethodsConfig;
}

interface UpdateAllowedPaymentMethodsModeParams {
  locationId: string;
  bypassStripePaymentMethodConfig: boolean;
}

export const updateAllowedPaymentMethods = async (
  params: UpdateAllowedPaymentMethodsParams,
) => {
  const response = await baseAPI.patch<unknown>(
    ALLOWED_PAYMENT_METHODS_API_PATH,
    params,
  );
  return response.data;
};

export const updateAllowedPaymentMethodsMode = async (
  params: UpdateAllowedPaymentMethodsModeParams,
) => {
  const response = await baseAPI.patch<unknown>(
    ALLOWED_PAYMENT_METHODS_MODE_API_PATH,
    params,
  );
  return response.data;
};

export const useUpdateAllowedPaymentMethods = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateAllowedPaymentMethods,
    onSuccess: (_, variables) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ALLOWED_PAYMENT_METHODS, variables.locationId],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ENROLLMENT_PAYMENT_METHODS],
      });
    },
  });
};

export const useUpdateAllowedPaymentMethodsMode = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateAllowedPaymentMethodsMode,
    onSuccess: (_, variables) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ALLOWED_PAYMENT_METHODS, variables.locationId],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ENROLLMENT_PAYMENT_METHODS],
      });
    },
  });
};
